import axios from 'axios'
import { errorHandler } from '@/api/error-handler'

const BASE_URL = '/products'

export default {
  count: () => axios.get(`${BASE_URL}/count`)
    .then(response => response.data)
    .catch(errorHandler),

  list: (params) => axios.get(`${BASE_URL}`, { params: params })
    .then(response => response.data)
    .catch(errorHandler),

  retrieve: (id) => axios.get(`${BASE_URL}/${id}`)
    .then(response => response.data)
    .catch(errorHandler),

  uses: (id, params) => axios.get(`${BASE_URL}/${id}/uses`, { params: params })
    .then(response => response.data)
    .catch(errorHandler),

  types: () => axios.get(`${BASE_URL}/types`)
    .then(response => response.data)
    .catch(errorHandler),

  status: () => axios.get(`${BASE_URL}/status`)
    .then(response => response.data)
    .catch(errorHandler),

  firms: () => axios.get(`${BASE_URL}/firms`)
    .then(response => response.data)
    .catch(errorHandler),

  substances: () => axios.get(`${BASE_URL}/substances`)
    .then(response => response.data)
    .catch(errorHandler),

  cultivations: () => axios.get(`${BASE_URL}/cultivations`)
    .then(response => response.data)
    .catch(errorHandler),

  targets: () => axios.get(`${BASE_URL}/targets`)
    .then(response => response.data)
    .catch(errorHandler),

  classifications: () => axios.get(`${BASE_URL}/classifications`)
    .then(response => response.data)
    .catch(errorHandler),

  categories: () => axios.get(`${BASE_URL}/typecommercial`)
    .then(response => response.data)
    .catch(errorHandler)
}
